<section class="col-12 h-100 d-flex flex-column justify-content-between">
    <div class="overflow-auto">
        <span class="assessment-text-grey-ten assessment-text-bold-14">{{data.Heading}}</span>
        <div class="col-12 mt-3 w-100 d-flex flex-column flex-wrap flex-sm-row assessment-text-grey-ten assessment-text-regular-14">
            {{data.Content}}
        </div>
    </div>
    <div class="d-flex mt-3 gap-4 w-100">
        <button mat-buton class="btn-shade-2 px-3 w-100 assessment-text-semibold-14" (click)="onSubmit()">{{data.SubmitButton}}</button>
        <button mat-button class="btn-shade-1 px-3 w-100 assessment-text-semibold-14" (click)="closeAll()">{{'COMMON.CANCEL'|translate}}</button>
    </div>
</section>
